/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prettier/prettier */
/* eslint-disable operator-linebreak */

import moment from 'moment';
import { useEffect } from 'react';
import { FaDownload } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import PagamentoRealizadoDTO from '../../dtos/PagamentoRealizadoDTO';
import { useAnuidade } from '../../hooks/anuidade';
import Utils from '../../utils';
import { Container } from './styles';

export function PagamentosRealizados() {
  const history = useHistory();
  const { anuidade, pagamentosRealizados } = useAnuidade();

  useEffect(() => {
    if (
      !anuidade ||
      !pagamentosRealizados ||
      !pagamentosRealizados.numeroInscricao
    ) {
      history.replace('/');
    }
  }, []);

  function getDescricaoParcela(pagamento: PagamentoRealizadoDTO) {
    if (pagamento.qntParcelasCartao <= 1) {
      return 'À vista';
    }
    return `${pagamento.qntParcelasCartao}x parcelas`;
  }

  function getDescricaoCota(pagamento: PagamentoRealizadoDTO) {
    if (!pagamento.numeroAvos) {
      if (pagamento.cotaTotal === 0) {
        return 'Única';
      }
      const valorInicial =
        pagamento.cotaInicio === pagamento.cotaFim
          ? pagamento.cotaInicio
          : `${pagamento.cotaInicio}-${pagamento.cotaFim}`;
      return `${valorInicial}/${pagamento.cotaTotal}`;
    }
    if (pagamento.numeroAvos > 0) {
      if (pagamento.cotaFim > pagamento.cotaInicio) {
        return `${pagamento.cotaInicio} - ${pagamento.cotaFim}/${pagamento.cotaTotal}`;
      }
      if (pagamento.cotaTotal === 0) {
        if (pagamento.numeroAvos > 0) {
          return `${pagamento.numeroAvos}/12`;
        }
        return 'Única';
      }
      return `${pagamento.cotaInicio}/${pagamento.cotaTotal}`;
    }
    return '';
  }

  function getDataPagamento(pagamento: PagamentoRealizadoDTO) {
    if (!pagamento.dataPagamentoOuVencimento) {
      return '';
    }
    return moment(pagamento.dataPagamentoOuVencimento).format('DD/MM/YYYY');
  }

  function handleDownloadRecibo(pagamento: PagamentoRealizadoDTO) {
    window.open(
      `${window.location.origin}${window.location.pathname}rest/anuidade/reciboanuidade/cartao/${pagamento.idCartao}.pdf`,
    );
  }

  if (
    !anuidade ||
    !pagamentosRealizados ||
    !pagamentosRealizados.numeroInscricao
  ) {
    return null;
  }

  const { nomeInscrito, numeroInscricao, pagamentos } = pagamentosRealizados;

  return (
    <Container>
      <div className="col-md-12">
        <div className="alert alert-info text-center" role="alert">
          {`${nomeInscrito} - Inscrição: ${numeroInscricao}`}
        </div>
      </div>
      <div className="col-md-12">
        <div className="card mb-3">
          <div className="card-header text-white bg-danger">Pagamentos</div>
          <div className="card-body">
            <div className="content-table">
              <table className="table">
                <thead>
                  <th className="text-center">Parcela</th>
                  <th className="text-center">Cota</th>
                  <th className="text-center">Valor</th>
                  <th className="text-center">Data pagamento</th>
                  <th> </th>
                </thead>
                <tbody>
                  {pagamentos.map((pagamento) => (
                    <tr key={pagamento.id}>
                      <td className="text-center">
                        {getDescricaoParcela(pagamento)}
                      </td>
                      <td className="text-center">
                        {getDescricaoCota(pagamento)}
                      </td>
                      <td className="text-center">
                        {`R$ ${Utils.formatReal(pagamento.valor)}`}
                      </td>
                      <td className="text-center">
                        {getDataPagamento(pagamento)}
                      </td>
                      <td width={pagamento.pagamentoCartao ? 165 : 0}>
                        {pagamento.pagamentoCartao && (
                          <button
                            className="btn btn-block btn-success"
                            type="button"
                            onClick={() => handleDownloadRecibo(pagamento)}
                          >
                            <FaDownload size={20} />
                            {' Gerar recibo'}
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}
